import { Mic, Video, MessageCircle, PhoneOff } from "lucide-react";

export default function VideoChatFrame({ src, name = "ARIA", caption, tall = true }) {
  return (
    <div data-testid="videochat-frame">
      <div className="group relative overflow-hidden rounded-2xl border border-white/10 bg-black/60 shadow-[0_40px_120px_rgba(0,229,255,0.07)]">
        <img
          src={src}
          alt={`${name} — photorealistic AI virtual companion, concept visual`}
          className={`w-full object-cover object-top transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03] ${tall ? "aspect-[4/5]" : "aspect-video"}`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40" />

        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-4">
          <div className="flex items-center gap-2 rounded-full border border-white/10 bg-black/50 px-3 py-1.5 backdrop-blur-md">
            <span className="h-2 w-2 rounded-full bg-cyan-300" />
            <span className="text-[10px] font-bold tracking-[0.25em] text-white">CONCEPT PREVIEW</span>
          </div>
          <div className="rounded-full border border-white/10 bg-black/50 px-3 py-1.5 text-[10px] font-medium tracking-[0.2em] text-white/80 backdrop-blur-md">
            {name} · AI COMPANION
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-3 p-5">
          {[
            { icon: Mic, id: "mic" },
            { icon: Video, id: "camera" },
            { icon: MessageCircle, id: "chat" },
          ].map(({ icon: Icon, id }) => (
            <span
              key={id}
              data-testid={`videochat-control-${id}`}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/50 text-white/90 backdrop-blur-md transition-colors duration-300 hover:border-cyan-300/40 hover:text-cyan-200"
            >
              <Icon size={17} />
            </span>
          ))}
          <span
            data-testid="videochat-control-endcall"
            className="flex h-11 w-11 items-center justify-center rounded-full bg-red-500/90 text-white transition-colors duration-300 hover:bg-red-400"
          >
            <PhoneOff size={17} />
          </span>
        </div>
      </div>
      {caption && (
        <p data-testid="videochat-caption" className="mt-3 text-[11px] uppercase tracking-[0.2em] text-white/55">
          {caption}
        </p>
      )}
    </div>
  );
}
